var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"content"},[_c('span',{staticClass:"text"},[_c('ParsedMessage',{attrs:{"network":_vm.network,"text":_vm.cleanText}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }